import httpClient from "@/services/HttpService";

export default {

    findAll: async () => {
        return (await httpClient.get(`/tipo-controllo/qualita/`)).data;
    },

}
